import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import { Label, Select } from '@shared/components';
import type { ProductFeeFormInput } from '../../schemas/productFee.schema';
import type { RefLabel } from '../../services/productFees';

interface Props {
    control: Control<ProductFeeFormInput>;
    targets: RefLabel[];
    isLoading: boolean;
    locked: boolean;
    lockedHint: string;
    unroutedCode: string | null;
}

const FIELDS = [
    { name: 'paid_by_id', label: 'Paid By', placeholder: 'Select paid by' },
    { name: 'paid_to_id', label: 'Paid To', placeholder: 'Select paid to' },
] as const;

export const PayerFields: React.FC<Props> = ({ control, targets, isLoading, locked, lockedHint, unroutedCode }) => (
    <>
        {FIELDS.map(({ name, label, placeholder }) => (
            <div key={name}>
                <Label htmlFor={name} required>{label}</Label>
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error: fe } }) => (
                        <Select
                            id={name}
                            ariaLabel={label}
                            placeholder={placeholder}
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            disabled={locked}
                            error={!!fe}
                            hint={fe?.message ?? (locked ? lockedHint : undefined)}
                            isLoading={isLoading}
                            options={targets.map((t) => ({ value: t.id, label: t.name }))}
                        />
                    )}
                />
            </div>
        ))}
        {unroutedCode !== null && (
            <p role="alert" className="text-sm text-mp-error md:col-span-2">
                {`The transaction type ${unroutedCode} has no payer pair configured, so this fee cannot be added to a product.`}
            </p>
        )}
    </>
);
